import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { NavLink } from 'react-router-dom';
import './HomePage.css'; // Import the CSS file
import './StorePage.css'; // Import the CSS file
import {
  GetCategorysFirstTypeSet,
  getDefaultCategoriesSet,
  findCategoryByType,
  getTypesByCategory,
  GetCategoryTypesSet,
  renderCategoryTypesDom,//render lefe nav menu
  getWordTagsCategoryByType,
  GetWordTagsCategoryTypesSet,
  renderWordTagsCategoryTypesDom
} from './LemmaCategoryTypeUtils';
import { AddWordProfileActions,getWordTags } from './LemmaTagUtils';
// import WordTags from './LemmaWordTags';
import { parselemmaUrlParams } from './LemmaPageUtils'
import { Pagination,generateCanonicalLink } from './Paginationhref';
import useLocation from './useLocation';
import CategorySelect from './CategorySelect';
import { categoryIcons } from './CategoryIcons';
import GeocodeModal from './GeocodeModal';
import CmnLemmaDisplay from './CmnLemmaParseHeadUtils'
import LocalStorageUtil from './user/LocalStorageUtil'
import { fetchHeadwordSuggestions } from './popuputils';
import LemmaProgress from './LemmaProgress'
import './popupstyle.css';

function CmnLemmaPage() {
  const cmnlemmapath = 'cmnlemma';
  const cmnlangcode = 'cmn';
  const cmnsearchsgn ="cmnlemmasuggestion"
  const navigate = useNavigate();
  const [session, setSession] = useState(null);
  const [isSortMenuVisible, setIsSortMenuVisible] = useState(false);
  const [sortOption, setSortOption] = useState('BestMatch');
  const baseHostUrl = process.env.NODE_ENV === 'production' ? 'https://growlemma.com' : 'http://localhost:80';
  const baseLocalDevUrl = process.env.NODE_ENV === 'production' ? 'https://growlemma.com' : 'http://localhost:3000';
  const [CateTypelinks, setCateTypelinks] = useState([]);
  const [CateTypeslinks, setCateTypeslinks] = useState([]);
  const [WordTagslinks, setWordTagslinks] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [basePath, setBasePath] = useState(`${baseLocalDevUrl}/${cmnlemmapath}/all?page=1`);
  const [curpage, setCurpage] = useState(1);

  const [suggestions, setSuggestions] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  // Assuming you have a state to keep track of items
  
  const itemsPerPage = 30; // assuming 10 items per page
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedWordTagsCategory, setselectedWordTagsCategory] = useState('all');
  const [selectedType, setSelectedType] = useState('all');
  const [searchName, setSearchName] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [totalItems, setTotalItems] = useState(0); // initialize to 1 to render pagination early
  //const totalItems = 300; // for example, if you have 180 items
  //const totalItems = searchResults.length > 0 ? searchResults[0].userRatingsCount || 0 : 0;

  const handleSortButtonClick = () => {
    // console.log('Sort button clicked. Current state is:', !isSortMenuVisible); // This should log the expected state chang
    setIsSortMenuVisible(!isSortMenuVisible);
  };

  const handleSortOptionChange = (option) => {
    setSortOption(option);
    setIsSortMenuVisible(false);
    setCategorysFirstType(option);
    triggerSearch(selectedType, searchName, option)
  };


  // Handle the key down event
  const handleKeyDown = (event) => {
    // Check if the Enter key was pressed
    if (event.key === 'Enter') {
      handleSearch();
    }
  };
  const handleCategoryChange = (event) => {
    const newCategory = event.target.value;
    setSelectedCategory(newCategory);
    // If 'all' is not selected, set the first type of the new category as selected
    const typesSet = getTypesByCategory(newCategory);
    if (newCategory !== 'all' && typesSet.length > 0) {
      setSelectedType(typesSet[0]);
    } else {
      setSelectedType('all');
    }
  };

  const handleTypeChange = (event) => {
    setSelectedType(event.target.value);
  };

 

  const handleSearchInputChange2 = (event) => {
    setSearchName(event.target.value || 'all');
  };

  const handleSearchInputChange = async (event) => {
    const value = event.target.value;
    setSearchName(value);
    // if(value.length < 3){
    //   return;
    // }
    if (value.length >= 3) {
      const results = await fetchHeadwordSuggestions(baseHostUrl,selectedType, value,sortOption,cmnsearchsgn);
      setSuggestions(results);
      setShowPopup(true);
    } else {
      setSuggestions([]);
      setShowPopup(false);
    }
  };

  const handleSearch = () => {
    triggerSearch(selectedType, searchName, sortOption);
  };
  

  // Function to trigger the search request
  const triggerSearch = (selectedType, searchName, sortBy) => {
    const name = searchName.trim() !== '' ? searchName : 'all';
    const sortby = sortBy;
    const rating = '=-1';
    const user_ratings_total = '=-1';
    const {para_wordtags } = parselemmaUrlParams();
    // Call handleSearch with the prepared parameters
    //force to use all for para_wordtag and selectedType
    const para_wordtags_2 ='all';
    selectedType ='all';

    let query = `${baseLocalDevUrl}/${cmnlemmapath}/${encodeURIComponent(selectedType)}?page=1`;

    if (name !== 'all') {
      query += `&name=${encodeURIComponent(name)}`;
    }

    if (sortby !== 'best-match') {
      query += `&sort=${encodeURIComponent(sortby)}`;
    }
    query += `&wordtag=${encodeURIComponent(para_wordtags_2)}`;
     // navigate(query)
     window.location.href = query;
    
    // handleRequst(type, name, sortby,rating,user_ratings_total);
    // fetch(query) to make the actual request, then process the response
  };
  const { locationElement, latitude, longitude } = useLocation();
  // Function to perform the actual search
  const handleRequst = async (type,wordtag, name, rating, user_ratings_total, sortby, curpage) => {

    const query = `${baseHostUrl}/cmnlemmasearch?type=${encodeURIComponent(type)}` + 
      `&wordtag=${encodeURIComponent(wordtag)}` +
      `&name=${encodeURIComponent(name)}` +
      `&rating=${rating}&user_ratings_total=${user_ratings_total}` +
      `&sortby=${encodeURIComponent(sortby)}` +
      `&lat=${encodeURIComponent(latitude)}&lon=${encodeURIComponent(longitude)}` +
      `&page=${encodeURIComponent(curpage)}`;

      let pageurl = `${baseLocalDevUrl}/${cmnlemmapath}/${encodeURIComponent(type)}?page=1`;
      pageurl += `&wordtag=${encodeURIComponent(wordtag)}`;
      if (name !== 'all') {
        pageurl += `&name=${encodeURIComponent(name)}`;
      }

      if (sortby !== 'best-match') {
        pageurl += `&sort=${encodeURIComponent(sortby)}`;
      }

    setBasePath(pageurl);
    setCurpage(+curpage);
    try {
      const response = await axios.get(query, {
        withCredentials: true
      });
      const data = response.data;
      setSearchResults(data); // Assuming the response is an array of objects
      setTotalItems(data.length > 0 ? data[0].userRatingsCount || 0 : 0);
    } catch (error) {
      console.error('Failed to fetch search results:', error);
    }
  };
  // useEffect hook to run once the component is mounted
  const setCategorysFirstType = (sortOption) => {
     // Utility: generate first type within each category, with sortOption
    const generatedLinks = GetCategorysFirstTypeSet(baseLocalDevUrl, sortOption,cmnlemmapath);
    setCateTypelinks(generatedLinks);
  };
  // left side types list for a category:
  const setCategoryTypesNav = (selectedCategory,para_wordtags, sortOption) => {
  //Utility: generate nav links for all types under a category,with sortoption
  const generatedLinks = GetCategoryTypesSet(selectedCategory, baseLocalDevUrl,para_wordtags, sortOption,cmnlemmapath);
    setCateTypeslinks(generatedLinks);
  };

  // left side types list for a category:
  const setWordTagsCategoryTypesNav = (selectedWordTagsCategory,para_type, sortOption) => {
    //Utility: generate nav links for all types under a category,with sortoption
    const generatedLinks = GetWordTagsCategoryTypesSet(selectedWordTagsCategory, baseLocalDevUrl, para_type,sortOption,cmnlemmapath);
      setWordTagslinks(generatedLinks);
    };

    const handleSuggestionClick = (suggestion) => {
      const name = suggestion.display_name;
    
      setSearchName(name);       // ✅ update the input value
      setSuggestions([]);        // ✅ hide popup
      setShowPopup(false);
    
      // ✅ triggerSearch using current selectedType and sortBy
      triggerSearch(selectedType, name, sortOption);
    }; 
  useEffect(() => {
    //for generate category-first-type link
    const data = LocalStorageUtil.getSession();
    setSession(data);
    // for loading results
    const { para_type, para_name, para_rating, para_reviews, para_sort_by,para_page, para_wordtags } = parselemmaUrlParams();

    const category = findCategoryByType(para_type);
    //console.log('cmn,lemma,category:',category,'para_type',para_type); // This should log the expected state chang
    const WordTagsCategory = getWordTagsCategoryByType(para_wordtags);
    setSelectedCategory(category);
    setSelectedType(para_type);
    //setSearchName(para_name);
    setSortOption(para_sort_by);
     // Utility: generate first type within each category, with sortOption
    setCategorysFirstType(para_sort_by);
    // Utility: generate nav links for all types under a category,with sortoption
    setCategoryTypesNav(category,para_wordtags, para_sort_by);

    setWordTagsCategoryTypesNav(WordTagsCategory, para_type,para_sort_by)
    handleRequst(para_type,para_wordtags, para_name, para_rating, para_reviews, para_sort_by, para_page).then(() => {
      setIsLoaded(true);
    });;

  }, []); // The empty array means this effect runs only once after initial render

  const { para_type } = parselemmaUrlParams();
  const { para_wordtags } = parselemmaUrlParams();
  const category = findCategoryByType(para_type);
  const [showModal, setShowModal] = useState(false);

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  return (
    <>
      <div className="hpTopBanner">
      <Helmet>
      <title>find best place of {para_type} in ottawa</title>
      <meta name="description"
      content="Learn english"/>

      </Helmet>
      {generateCanonicalLink({ basePath,curpage })}
        <span className="hpLogo">Iezloc</span>
        <span className="hplocation"></span>
        {/* <span className="hplocation" onClick={handleShowModal}>
          {locationElement}</span>
        <GeocodeModal show={showModal} handleClose={handleCloseModal} currentUrl={basePath} /> */}
        <ul className="hpNavigationMenu">
          <li><NavLink to="/" className={({ isActive }) => (isActive ? 'activeLink' : '')}>Home</NavLink></li>
          <li><NavLink to="/lemma" className={({ isActive }) => (isActive ? 'activeLink' : '')} >Lemma</NavLink></li>
          {!session && (
        <>
          <li><NavLink to="/login" className={({ isActive }) => (isActive ? 'activeLink' : '')}>Login</NavLink></li>
          <li><NavLink to="/signup" className={({ isActive }) => (isActive ? 'activeLink' : '')}>Signup</NavLink></li>
        </>
      )}

      {session && (
        <>
         <li><NavLink to="/progress" className={({ isActive }) => (isActive ? 'activeLink' : '')}>Progress</NavLink></li>
          <li><NavLink to="/cmnlemma"  className={({ isActive }) => (isActive ? 'activeLink' : '')} >Cmnlemma</NavLink></li>
          <li><NavLink to="/cmnprogress" className={({ isActive }) => (isActive ? 'activeLink' : '')}>Cmnprogress</NavLink></li>
          <li><NavLink to="/cmnphrase" className={({ isActive }) => (isActive ? 'activeLink' : '')}>Cmnphrase</NavLink></li>
          <li><NavLink to="/frelemma" className={({ isActive }) => (isActive ? 'activeLink' : '')}>Frelemma</NavLink></li>
          <li><NavLink to="/freprogress" className={({ isActive }) => (isActive ? 'activeLink' : '')}>Freprogress</NavLink></li>
          <li><NavLink to="/cmnbook" className={({ isActive }) => (isActive ? 'activeLink' : '')}>Cmnbook</NavLink></li>
          <li><NavLink to="/dashboard" className={({ isActive }) => (isActive ? 'activeLink' : '')}>Dashboard</NavLink></li>
          <li><NavLink to="/logout" className={({ isActive }) => (isActive ? 'activeLink' : '')}>Logout</NavLink></li>
        </>
      )}

        </ul>
      </div>
      <div className="spContainer">
        <div className="spNavRow1">
          <CategorySelect
            selectedCategory={selectedCategory}
            handleCategoryChange={handleCategoryChange}
            categories={getDefaultCategoriesSet()}
            cateClassname="spCategory"
          />
          <select
            value={selectedType}
            onChange={handleTypeChange}
            className="spType"
            disabled={selectedCategory === 'all'} // Disable if 'All'-categories are selected
          >
            {/* Render the 'All' option only if the selected category is 'all' */}
            {selectedCategory === 'all' && <option value="all">All</option>}
            {getTypesByCategory(selectedCategory).map((type, index) => (
              <option key={index} value={type}>
                {type}
              </option>
            ))}
          </select>
          <div className="spInputContainer">
            <input
              className="spInputWords"
              type="text"
              value={searchName}
              onChange={handleSearchInputChange}
              onKeyDown={handleKeyDown}
              placeholder="Search headword"
            />
            <button className="spInputButton" onClick={handleSearch} tabIndex="0">Search</button>
            {showPopup && suggestions.length > 0 && (
              <ul className="spSuggestionList">
                {suggestions.map((item, index) => (
                  <li key={index} className="spSuggestionItem" onClick={() => handleSuggestionClick(item)}>
                    {item.display_name}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
        <div className="spNavRow2">
          <button className="spSortButton" onClick={handleSortButtonClick}>
            Sort by <span className="spSortText">{sortOption.replace(/([A-Z])/g, ' $1').trim()}</span>
            <span className="spSortArrow">^</span>
          </button>
          {isSortMenuVisible && (
            <div className={`spSortMenu ${isSortMenuVisible ? 'visible' : ''}`}>
              <div onClick={() => handleSortOptionChange('best-match')}>Best Match</div>
              <div onClick={() => handleSortOptionChange('wordtag-time-desc')}>Newest to oldest</div>
              <div onClick={() => handleSortOptionChange('wordtag-time-asc')}>Oldest to Newest </div>
              {/* <div onClick={() => handleSortOptionChange('rating-asc')}>Rating: low to high</div>
              <div onClick={() => handleSortOptionChange('rating-desc')}>Rating: high to low</div>
              <div onClick={() => handleSortOptionChange('reivew-asc')}>Reviews Total: low to high</div>
              <div onClick={() => handleSortOptionChange('review-desc')}>Reviews Total: high to low</div>
              <div onClick={() => handleSortOptionChange('distance-near-far')}>Distance : near to far</div> */}
              {/* <div onClick={() => handleSortOptionChange('distance_far_near')}>Distance : far to near</div> */}
            </div>
          )}
        </div>
        <div className='spNavRow3'>
          {CateTypelinks.map((link, index) => (
            <a key={index} href={link.url} className={`spNavCategoryLink ${link.category === category ? 'sphighlight' : ''}`}>
              <i className={categoryIcons[link.name]} style={{ marginRight: '8px' }}></i>
              {link.name}
            </a>
          ))}
        </div>
        <div className="spTwoColGrid">
          <div className="spLeftNav1">
          {renderWordTagsCategoryTypesDom(WordTagslinks, para_wordtags)}
          {renderCategoryTypesDom(CateTypeslinks, para_type)}
          </div>

          <div className="spResultsGrid">
            {searchResults.map((store, index) => (
              <div className="spStoreGrid" key={index}>
                <div className="spStoreInfo">
                  {session?.username && (
                <AddWordProfileActions
                  baseHostUrl={baseHostUrl}
                  session={session}
                  wordlemma={store}
                  wordtags={store.mapurl}
                  langcodename={cmnlangcode}
                />
              )}
                  {getWordTags(store.mapurl)}
                   <CmnLemmaDisplay 
                   lemmashead={store.formattedAddress} 
                   lemmachs={store.website} 
                   headword={store.display_name} 
                   showlemma={session?.usrprofile?.showlemma}
                   langcodename={cmnlangcode}/>
                </div>
                 {/* TODO: remove this spStoreImage later,it will have occupancy of half right side  */}
                <div className="spStoreImage">
                  <img src={`${store.iconMaskBaseUri}`} alt="" style={{ backgroundColor: store.iconBackgroundColor }} />
                </div>

              </div>
            ))}
          </div>
        </div>
        <div className="spNavRow4">
        {totalItems > 0 && (
          <Pagination
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            basePath={basePath}
            curPage={curpage}
          />
        )}
        </div>
      </div>
      <div className={`hpBottomBanner ${isLoaded ? 'visible' : 'hidden'}`}>
        <span className="hpCopyRight">Copyright © iezloc 2024</span>
        <span className="hpContact">info@iezloc.com</span>
        <Link to="/privacy-policy" className="hpPrivacyPolicy">Privacy Policy and Disclaimer</Link>
      </div>
    </>
  );
}


export default CmnLemmaPage;

